import {Tag} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {getAbuseLogStatusLocaleKey} from '../../../../../../../../service/reviews/reviews-abuse-log-helper';

import * as styles from './history-modal.scss';

type PropsType = {
    status: string;
};

export function AbuseStatusBadge(props: PropsType): ReactElement | null {
    const {status} = props;

    if (!status) {
        return null;
    }

    const localeKey = getAbuseLogStatusLocaleKey(status);

    return (
        <Tag className={styles.HistoryModal_abuseStatusBadge}>
            {localeKey ? (
                <Text bolder lighter small stringKey={localeKey} />
            ) : (
                <Text bolder lighter small>
                    {status}
                </Text>
            )}
        </Tag>
    );
}
